// extracted by mini-css-extract-plugin
module.exports = {"link":"_307BA","ScotchTapeButton":"_3HmKP","scotchTapeButton":"_3HmKP","label":"_2fade","left":"_30q9Y","right":"_2xrZz"};